module.exports = __webpack_public_path__ + "static/img/why-5.6ed60b2c.png";